import { useTranslation } from "react-i18next"

type Props = {
  completion: number
}

const progressionBarBaseStyle =
  "hover:bg-cortexx-550 p-0.5 rounded-full text-xs text-cortexx-50 text-center transition-all duration-300 ease-in-out"

export const ProgressionBar = ({ completion }: Props) => {
  const { t } = useTranslation()
  const progressionBarStyle =
    completion === 0
      ? progressionBarBaseStyle
      : `bg-cortexx-500 ${progressionBarBaseStyle}`

  return (
    <div className="flex flex-row w-screen md:w-[500px] md:mx-8 items-center justify-center mb-2 px-2">
      <div className="hidden md:flex font-semibold text-cortexx-550 mr-4">
        {t("state.progression")}
      </div>
      <div className="w-full md:w-[500px] bg-gray-200 rounded-full">
        <div
          className={progressionBarStyle}
          style={{
            width: `${completion}%`
          }}
        >
          {completion}%
        </div>
      </div>
    </div>
  )
}
